export default __webpack_public_path__ + "static/media/list-loader.926591e8.svg";